

export function OnlineStatusDot() {
    return (
        <div className="status-indicator circle-online-color"></div>
    );
}

export function OfflineStatusDot() {
    return (
        <div className="status-indicator circle-offline-color"></div>
    );
}